// extracted by mini-css-extract-plugin
export default {"spinner":"spinner_spinner__TIHEX","dark":"spinner_dark__UfHgD"};